"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FaqItem_1 = __importDefault(require("./FaqItem"));
const FaqSectionStyled_1 = __importDefault(require("./FaqSectionStyled"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const FaqSection = ({ data, expandAll = true }) => {
    const { image, title, subTitle, faqList } = data;
    return (react_1.default.createElement(FaqSectionStyled_1.default, { className: "ecr-faqSection" },
        react_1.default.createElement("div", { className: "ecrfs-left" },
            react_1.default.createElement("h1", null, title),
            react_1.default.createElement("h5", null, subTitle),
            react_1.default.createElement("div", { className: "ecrfs-faq-list" }, faqList.map((faq, index) => {
                return react_1.default.createElement(FaqItem_1.default, { data: faq, key: index, defaultExpand: expandAll });
            }))),
        react_1.default.createElement("div", { className: "ecrfs-right" },
            react_1.default.createElement("img", { src: image, alt: "faq" }))));
};
FaqSection.propTypes = {
    data: prop_types_1.default.object,
    expandAll: prop_types_1.default.bool
};
exports.default = FaqSection;
//# sourceMappingURL=FaqSection.js.map